import CommonToggleContainer from "../../Common/CommonToggleContainer";
import ToggleItem from "../../Common/ToggleItem";
import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import RechargeOnlineLayer from "../Recharge/RechargeOnlineLayer";
import RechargeCodeLayer from "../Recharge/RechargeCodeLayer";
import RechargeAgentLayer from "../Recharge/RechargeAgentLayer";
import RechargeOfflineLayer from "../Recharge/RechargeOfflineLayer";
import Utils from "../../Shared/Utils";
import Constant from "../../Shared/Constant";
import AudioManager from "../../Shared/AudioManager";
import { Global } from "../../Shared/Global";
import HallUI from "../HallUI";
import EnterSoundManager from "../../Shared/EnterSoundManager";
import RechargeUSDTLayer from "./RechargeUSDTLayer";


const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeUI extends cc.Component {    
    @property(cc.Prefab)
    pfbCustomerServiceUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbRechargeRecords: cc.Prefab = null
    
    @property(RechargeOnlineLayer)
    rechargeOnlineLayer: RechargeOnlineLayer = null

    @property(RechargeOfflineLayer)
    rechargeOfflineLayer: RechargeOfflineLayer = null

    @property(RechargeCodeLayer)
    rechargeCodeLayer: RechargeCodeLayer = null

    @property(RechargeAgentLayer)
    rechargeAgentLayer: RechargeAgentLayer = null

    @property(RechargeUSDTLayer)
    rechargeUSDTLayer: RechargeUSDTLayer = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null

    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Node)
    nodeCourse: cc.Node = null

    @property(cc.Node)
    rechargeCourseLayer: cc.Node = null;

    private _chargeTypelist: Array<any> = []
    private _isOpenedThirdPayment = false;
    bJump = false;
    jumpChargeTypeIdArr = [];
    courseData = null;
    rechargeCourseList = [];

    //yinShangDomain = null;

    onLoad () {
        this.rechargeOnlineLayer.node.active = false
        this.rechargeOfflineLayer.node.active = false
        this.rechargeCodeLayer.node.active = false
        this.rechargeAgentLayer.node.active = false
        this.rechargeUSDTLayer.node.active = false
        //this.nodeCourse.active = false
        cc.game.on(cc.game.EVENT_SHOW, this.onGameShow, this)
        cc.director.on(Global.UserEvent.OpenThirdPayment, this.onOpenThirdPayment, this)
    }
    
    start () {
        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtNode.left += Constant.BangLength;
        }

        Utils.hideGameNode()
        this.pullChargeTypelist()
        EnterSoundManager.playSound("enter_chongzhi")
    }

    onDestroy () {
        cc.game.off(cc.game.EVENT_SHOW, this.onGameShow, this)
        cc.director.on(Global.UserEvent.OpenThirdPayment, this.onOpenThirdPayment, this)
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        }else if (userData === "record") {
            this.showRecordUI()
        }else if (userData === "weidaozhang") {
            let hallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent(HallUI)
            hallUI && hallUI.openChildUI(this.pfbCustomerServiceUI)
            this.node.destroy()
        }else if (userData === "course") {
            if(this.courseData && this.courseData.jumpType === 2){//跳转方式 1:app  2: 外部
                cc.sys.openURL(this.courseData.jumpUrl)
            }else if (this.courseData && this.courseData.jumpType === 1){
                this.rechargeCourseLayer.active = true;
                this.rechargeCourseLayer.getComponent("RechargeCourse").updateUI(this.courseData.imgs);
            }

        }
    }

     async onToggleSelected(toggle: ToggleItem) {
        // 目前只有usdt有充值教程
        //this.nodeCourse.active = false
        cc.log("====进入onToggleSelected");
        let flag = parseInt(toggle.userData["flag"])
        let chargeTypeId = toggle.userData["id"]

        let bCourseActive = false;
        let dataArr = await this.checkCourseByTypeId(chargeTypeId);
        bCourseActive = dataArr[0];
        cc.log("===bCourseActive:",bCourseActive);
        this.nodeCourse.active = bCourseActive;
        this.courseData = dataArr[1];
        // 标识，0 线上 1 线下 2 线下扫码
        if (flag === 0) {
            UIManager.showLoadingUI()
            NetworkLogic.getNewConfigMoneyInOnline(chargeTypeId, function (data) {
                UIManager.hideLoadingUI()
                this.showInfoLayer(toggle.userData, data)
            }.bind(this))
        } else if (flag === 1) {
            UIManager.showLoadingUI()
            NetworkLogic.getNewConfigMoneyInOfficialTransfer(chargeTypeId, function (data) {
                UIManager.hideLoadingUI()
                this.showInfoLayer(toggle.userData, data)
            }.bind(this))
        } else if (flag === 2) {
            UIManager.showLoadingUI()
            NetworkLogic.getNewConfigMoneyInSolidcode(chargeTypeId, function (data) {
                UIManager.hideLoadingUI()
                this.showInfoLayer(toggle.userData, data)
            }.bind(this))
        } else if (flag === 3) {
            UIManager.showLoadingUI()
            NetworkLogic.getConfigMoneyInVip(chargeTypeId, function (data) {
                UIManager.hideLoadingUI()
                this.showInfoLayer(toggle.userData, data)
            }.bind(this))
        } else if (flag === 4) {
            //this.nodeCourse.active = true
            UIManager.showLoadingUI()
            NetworkLogic.getNewConfigMoneyInUSDT(chargeTypeId, function (data) {
                UIManager.hideLoadingUI()
                this.showInfoLayer(toggle.userData, data)
            }.bind(this))
        }
    }

    async checkCourseByTypeId(typeId) {

        if (this.rechargeCourseList.length <= 0) {
            await this.getRechargeCourseList()
        }
        cc.log("=====typeId:",typeId);

        let bTypeId = false;
        let data = null;
        for (let i = 0;i < this.rechargeCourseList.length;i++){
            if (this.rechargeCourseList[i].chargeTypeNameId === typeId){
                bTypeId = true;
                data = this.rechargeCourseList[i];
                break;
            }
        }
        return [bTypeId,data];
    }

    getRechargeCourseList():Promise<any>{

        return new Promise(resolve => {
            if(this.rechargeCourseList.length > 0){
                resolve (this.rechargeCourseList);
            }
            UIManager.showLoadingUI();
            NetworkLogic.rechargeCourseList({},function (rec) {
                cc.log("====教程list：",rec);
                UIManager.hideLoadingUI();
                this.rechargeCourseList = rec;
                resolve(this.rechargeCourseList);
            }.bind(this),function () {
                resolve();
            }.bind(this))
        })
    }

    onGameShow () {
        if (this._isOpenedThirdPayment) {
            this._isOpenedThirdPayment = false
            this.showRecordUI()
        }
    }
    
    onOpenThirdPayment () {
        this._isOpenedThirdPayment = true
    }

    private pullChargeTypelist () {
        UIManager.showLoadingUI()
        NetworkLogic.chargeTypelist(function (data) {
            UIManager.hideLoadingUI()
            cc.log("====拉取充值列表 parentConfigs：",data);
            this._chargeTypelist = data.list
            this.scheduleOnce(function () {
                this.createToggles()
            }, 0.3)
        }.bind(this), function (response) {
            !response && UIManager.showChangeDomainUI(function () {
                this.pullChargeTypelist()
            }.bind(this))
        }.bind(this))
    }

    private showRecordUI () {
        if (!this.node.getChildByName("recordLayer")) {
            let node = cc.instantiate(this.pfbRechargeRecords)
            node.name = "recordLayer"
            node.parent = this.node
        }
    }

    private createToggles() {
        this.toggleContainer.isSelectFirstItem = !this.bJump
        this._chargeTypelist.forEach(item => {
            let toggle = this.toggleContainer.addDefaultToggle(item.chargeName, item)
            let nodeFlag = new cc.Node();
            let spFlag = nodeFlag.addComponent(cc.Sprite)

            nodeFlag.setAnchorPoint(1, 1)
            nodeFlag.position = cc.v2(toggle.node.width * toggle.node.anchorX, toggle.node.height * toggle.node.anchorY)
            nodeFlag.parent = toggle.node

            if (item.chargeCornerUrl) {
                cc.loader.load({url: item.chargeCornerUrl, type: "png"}, function (err, texture) {
                    if (!err && spFlag && spFlag.isValid) {
                        spFlag.spriteFrame = new cc.SpriteFrame(texture)
                    }
                }.bind(this))
            }
        });
        let typeIdArr = this._chargeTypelist.filter((item)=>{
            if (this.jumpChargeTypeIdArr.indexOf(item.chargeTypeId.toString())> -1){
                return true;
            }
        })

        if (this.bJump && typeIdArr.length > 0){
            let node = this.toggleContainer.node;
            let layout = node.getComponent(cc.Layout)
            layout.updateLayout();
            let scroll = this.toggleContainer.node.parent.parent.getComponent(cc.ScrollView);

            let children = this.toggleContainer.node.children;
            for (let i = 0;i < children.length;i++){
                let toggle = children[i].getComponent(ToggleItem);
                if(toggle.userData["chargeTypeId"] === typeIdArr[0].chargeTypeId){
                    let offset1 = 1 *  i/ children.length;
                    scroll.scrollTo(cc.v2(0, 1- offset1), 0.1);
                    this.toggleContainer.selectToggle(toggle);

                    break;
                }
            }
            this.bJump = false;
        }else{
            
            this.toggleContainer.selectFirstItem()
        }
    }



    async showInfoLayer(parentConfig, configs) {
        this.rechargeOnlineLayer.node.active = false
        this.rechargeOfflineLayer.node.active = false
        this.rechargeCodeLayer.node.active = false
        this.rechargeAgentLayer.node.active = false
        this.rechargeUSDTLayer.node.active = false
        let flag = parseInt(parentConfig["flag"])

        // 平台在线充值
        if (flag === 0) {
            this.rechargeOnlineLayer.parentConfig = parentConfig
            this.rechargeOnlineLayer.node.active = true
            this.rechargeOnlineLayer.configs = configs
        }
        // 平台线下转账
        else if (flag === 1) {
            this.rechargeOfflineLayer.parentConfig = parentConfig
            this.rechargeOfflineLayer.node.active = true
            this.rechargeOfflineLayer.configs = configs
        }
        // 扫码充值
        else if (flag === 2) {
            this.rechargeCodeLayer.parentConfig = parentConfig
            this.rechargeCodeLayer.node.active = true
            this.rechargeCodeLayer.configs = configs
        }
        // 代理在线充值
        else if (flag === 3) {
            this.rechargeAgentLayer.parentConfig = parentConfig
            this.rechargeAgentLayer.node.active = true
            this.rechargeAgentLayer.configs = configs.seatList
            let yinShangDomain = configs.H5Domain;
            this.rechargeAgentLayer.yinShangDomain = yinShangDomain;
            //this.rechargeAgentLayer.imgPrefix = configs.imgPrefix
        }
        // usdt充值
        else if (flag === 4) {
            this.rechargeUSDTLayer.parentConfig = parentConfig
            this.rechargeUSDTLayer.node.active = true
            this.rechargeUSDTLayer.configs = configs
            cc.log("===usdt充值configs：", configs);
        }
    }
}
